import React from "react";
const getFillColor = (color: string) => {
    return color === "currentColor" ? `currentColor` : `var(--color-${color})`;
};
const SvgPinterestColorIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#clip0_12_63)">
      <path fill={getFillColor(props.color) === "currentColor" ? `var(--color-pinterest-logo-white)` : getFillColor(props.color)}
        d="M31.9962 16.0038C31.9962 24.8383 24.8344 32 16 32C7.16558 32 0.00384521 24.8383 0.00384521 16.0038C0.00384521 7.16942 7.16558 0.00768189 16 0.00768189C24.8344 0.00768189 31.9962 7.16942 31.9962 16.0038Z"/>
      <path fill={getFillColor(props.color) === "currentColor" ? `var(--color-pinterest-logo-red)` : getFillColor(props.color)}
        d="M10.0615 30.8528C9.86151 29.0333 10.0014 27.2937 10.4013 25.6141L12.001 18.7158C11.7411 17.876 11.5411 16.9162 11.5411 15.9564C11.5411 13.717 12.6208 12.1173 14.3204 12.1173C15.5001 12.1173 16.36 12.9372 16.36 14.5168C16.36 15.0167 16.2599 15.5765 16.06 16.2163L15.3602 18.5158C15.2202 18.9557 15.1602 19.3756 15.1602 19.7355C15.1602 21.3352 16.3799 22.2349 17.9395 22.2349C20.7189 22.2349 22.6984 19.3556 22.6984 15.6165C22.6984 11.4575 19.9791 8.79807 15.96 8.79807C11.4811 8.79807 8.64177 11.7174 8.64177 15.7765C8.64177 17.4161 9.14168 18.9357 10.1214 19.9755C9.80149 20.5153 9.46161 20.6153 8.94173 20.6153C7.34212 20.6153 5.82245 18.3558 5.82245 15.2766C5.82245 9.95786 10.0814 5.71894 16.06 5.71894C22.3384 5.71894 26.2775 10.0979 26.2775 15.4965C26.2775 20.9352 22.4385 25.0143 18.2995 25.0143C16.6598 25.0143 15.2202 24.3144 14.2204 23.0547L13.4006 26.374C12.9607 28.0935 12.3009 29.713 11.2411 31.2727C12.7408 31.7327 14.2204 31.9926 16 31.9926C24.8379 31.9926 31.9962 24.8343 31.9962 15.9964C31.9962 7.15853 24.8379 0.000245771 16 0.000245771C7.16213 0.000245771 0.00384521 7.15853 0.00384521 15.9964C0.00384521 22.6948 4.12288 28.4733 10.0615 30.8528Z"/>
    </g>
  </svg>
);

export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}

const SvgPinterestColorStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgPinterestColorIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? {style: {color: getFillColor(color), fill: getFillColor(color)}}
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const PinterestColorIcon: any = SvgPinterestColorStyle;
export default PinterestColorIcon;
